import Policies from './Policies';

export default Policies;
